import React from 'react';
import CircularProgress from '../../../components_base/CircularProgress';

const Store = React.lazy(() => import('../components/MyBonuses/Store'));

function StoreView() {
  return (
    <React.Suspense fallback={<CircularProgress />}>
      <Store/>
    </React.Suspense>
  );
}

export default StoreView;
